export const precedenceBasisLookup = (key, obj, precedence = []) => {
  for (let i = 0; i < precedence.length; i++) {
    const lookUpKey = `${precedence[i]}.${key}`
    if (obj[lookUpKey] !== undefined) {
      return obj[lookUpKey]
    }
  }
  return obj[key]
}

export const flattenObjectWithKeyPrefix = (obj, prefix = '') =>
  Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '.' : ''
    if (
      typeof obj[k] === 'object' &&
      obj[k] !== null &&
      !Array.isArray(obj[k])
    ) {
      Object.assign(acc, flattenObjectWithKeyPrefix(obj[k], pre + k))
    } else acc[pre + k] = obj[k]
    return acc
  }, {})

export const flattenObjectByPrecedence = (obj, precedenceInfo) => {
  const keyPrefixedFlattenedObject = flattenObjectWithKeyPrefix(obj)
  let result = {}
  for (const key in precedenceInfo) {
    const value = precedenceBasisLookup(
      key,
      keyPrefixedFlattenedObject,
      precedenceInfo[key]?.precedence || []
    )
    if (value !== undefined) {
      result[key] = value
    }
  }
  return result
}
